// src/features/leases/components/EstimatedValue.jsx
//
// LSE-LEASE-TAB-FINANCIAL-FALLBACK (#76) — hover tooltip wrapper for
// KPI values derived from total_cost ÷ term. Used on both the top
// stat tiles (StatCardLarge) and the Financial Terms panel
// (FinancialTermsCard).
//
// LSE-DERIVED-TOOLTIP-MISSING-ON-LEASE-TAB: restructured from the
// original inner-span-trigger pattern to the hover-zone parent
// pattern. onMouseEnter/Leave live on the outer container (which
// wraps BOTH the trigger text AND the popup). This prevents tooltip
// flicker: since both the trigger and the popup are descendants of
// the hover zone, mouseleave on the outer container never fires while
// the cursor transitions between them. The popup is not pointer-
// events:none — it must receive pointer events so the browser treats
// it as a descendant for mouseleave purposes.

import React from "react";
import { Tooltip } from "../../../components/Tooltip.jsx";
import { useHoverIntent } from "../../../components/useHoverIntent.js";

const DEFAULT_MESSAGE =
  "Derived value - estimated as total cost ÷ term length. Add per-year cost rows in the edit modal for actual values.";

export function EstimatedValue({ value, message }) {
  const { open, triggerProps, popupProps } = useHoverIntent({ interactive: true });
  const copy = message ?? DEFAULT_MESSAGE;
  return (
    <span
      data-testid="estimated-hover-zone"
      style={{ position: "relative", display: "inline-block", cursor: "help" }}
      {...triggerProps}
      tabIndex={0}
    >
      <span
        data-testid="estimated-indicator"
        tabIndex={0}
      >
        {value}
      </span>
      {open && (
        <Tooltip
          {...popupProps}
          data-testid="estimated-tooltip-popup"
          style={{
            bottom:    "100%",
            left:      "50%",
            transform: "translateX(-50%)",
            top:       "auto",
            zIndex:    10,
            lineHeight: 1.4,
            // pointer-events must stay on so hovering the popup doesn't
            // trigger a premature mouseleave on the hover zone.
            pointerEvents: "auto",
          }}
        >
          {copy}
        </Tooltip>
      )}
    </span>
  );
}
